const customSelectStyle = {
  container: (provided: any) => ({
    ...provided,
    position: 'absolute',
    top: 'auto',
    marginTop: '10px',
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: '16px',
    border: '1px solid #EBEBEB',
    borderRadius: '10px',
    zIndex: '2',
  }),
  menuList: (provided: any) => ({
    ...provided,
    paddingBottom: 0,
    paddingTop: 0,
    marginRight: '8px',
    overflow: 'hidden',
    overflowY: 'hidden',
    display: 'flex',
    height: '170px',
    zIndex: '2',
  }),
}
const InputSpecialitiesStyles = {
  customSelectStyle: customSelectStyle,
}

export { InputSpecialitiesStyles }
